import type { InferResponseType } from 'hono/client';
import { type ApiClient, useMutation } from '../api';

type PostFleetDeviceAssignments =
  ApiClient['v1']['workspaces'][':workspaceId']['fleets'][':fleetId']['device-assignments']['$post'];
type PostFleetDeviceUnassignments =
  ApiClient['v1']['workspaces'][':workspaceId']['fleets'][':fleetId']['device-unassignments']['$post'];

export type FleetBatchAssignmentResponse = InferResponseType<PostFleetDeviceAssignments, 200>;

type FleetBatchRequest = {
  fleetId: number;
  workspaceId: number;
  deviceIds: number[];
};

export const useAssignDevicesToFleet = () =>
  useMutation<FleetBatchAssignmentResponse, FleetBatchRequest>(
    'devices-fleet-batch-assignment',
    (client, { fleetId, workspaceId, deviceIds }) =>
      client.v1.workspaces[':workspaceId'].fleets[':fleetId']['device-assignments'].$post({
        param: { workspaceId: workspaceId.toString(), fleetId: fleetId.toString() },
        json: { deviceIds },
      })
  );

export const useUnassignDevicesFromFleet = () =>
  useMutation<InferResponseType<PostFleetDeviceUnassignments, 200>, FleetBatchRequest>(
    'devices-fleet-batch-unassignment',
    (client, { fleetId, workspaceId, deviceIds }) =>
      client.v1.workspaces[':workspaceId'].fleets[':fleetId']['device-unassignments'].$post({
        param: { workspaceId: workspaceId.toString(), fleetId: fleetId.toString() },
        json: { deviceIds },
      })
  );
